import { IRutinInfo } from '../../../../../Types/RutinInfoType';

const SYSStyrvardeMeny: IRutinInfo[] = [];

export default SYSStyrvardeMeny;
